import { render, staticRenderFns } from "./CustomerOrderList.vue?vue&type=template&id=46542f30&scoped=true"
import script from "./CustomerOrderList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderList.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderList.vue?vue&type=style&index=0&id=46542f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46542f30",
  null
  
)

export default component.exports